import { render, staticRenderFns } from "./ForceMsg.vue?vue&type=template&id=3170da4c&scoped=true"
import script from "./ForceMsg.vue?vue&type=script&lang=js"
export * from "./ForceMsg.vue?vue&type=script&lang=js"
import style0 from "./ForceMsg.vue?vue&type=style&index=0&id=3170da4c&prod&rel=stylesheet%2Fscss&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3170da4c",
  null
  
)

export default component.exports